export const ELASTICPATH_COOKIE_EXPIRE = 30

export const ELASTICPATH_CART_COOKIE = 'elasticpath_cart'

export const ELASTICPATH_CUSTOMER_COOKIE = 'elasticpath_customer'

export const ELASTICPATH_WISHLIST_COOKIE = 'elasticpath_wishlist'
